<template>
  <q-th :auto-width="autoWidth" :props="props" class="mi-th">
    <slot></slot>
  </q-th>
</template>

<script>
  export default {
    name: 'MiTh',
    props: {
      autoWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      props: {
        type: Object,
        required: false,
        default: () => {}
      }
    }
  }
</script>
